import React from 'react';

import CfaReleaseSignContainer from '../../../containers/cfa-release-sign-container';
import AppPageMain from '../../../modules/app-page/app-page--main';
import PageHeader from '../../../modules/page-header';

const CfaSign: React.FC = () => (
  <AppPageMain>
    <div className="container">
      <div className="row">
        <div className="col-19 col-lg-27 col-xl-35">
          <PageHeader
            items={[
              { link: '/assets', title: 'Активы' },
              { link: '#', title: 'Выпуск ЦФА' },
            ]}
            iconType="assets"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-19 col-lg-27 col-xl-35">
          <CfaReleaseSignContainer />
        </div>
      </div>
    </div>
  </AppPageMain>
);

export default CfaSign;
